import React, { useState } from 'react';
import { useChatStore } from '../../stores/useChatStore';
import './ChatInput.css';

export default function ChatInput() {
  const { sendMessage, streaming, usage } = useChatStore();
  const [text, setText] = useState('');

  const limitReached = usage ? usage.remaining <= 0 : false;
  const disabled = streaming || limitReached;

  async function submit(e?: React.FormEvent) {
    e?.preventDefault();
    const trimmed = text.trim();
    if (!trimmed || disabled) return;
    setText('');
    await sendMessage(trimmed);
  }

  function onKeyDown(e: React.KeyboardEvent<HTMLTextAreaElement>) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  }

  return (
    <form className="chat-input" onSubmit={submit}>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder={
          limitReached
            ? 'Tageslimit erreicht — kommt morgen wieder.'
            : 'Nachricht eingeben… (Enter zum Senden, Shift+Enter für Zeilenumbruch)'
        }
        rows={2}
        disabled={disabled}
      />
      <button type="submit" disabled={disabled || !text.trim()}>
        {streaming ? '…' : 'Senden'}
      </button>
    </form>
  );
}
